import InitialState from 'Store/InitialState';
import { studentGroupConceptsActionTypes as types } from 'Screens_old';
import produce from 'immer';

export default function studentGroupConceptsReducer(state = InitialState.studentGroupConceptsMap, action) {
    switch (action.type) {
        case types.LOAD_STUDENT_GROUP_CONCEPTS_SUCCESS:
            const { groupid, concepts } = action;
            // let newState = new Map(state)
            // newState.set(groupid, concepts);
            // return newState;
            return produce(state, (draftState) => {
                draftState[groupid] = concepts;
            })

        case types.LOAD_STUDENT_GROUP_CONCEPTS_FAILURE:
            return state;

        default:
            return state;
    }
}